"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.preview.errors.noId': '未提供付款ID',
    'payment.preview.errors.loadFailed': '加载付款详情失败',
    'payment.preview.refreshed': '付款详情已刷新',
};
